module.exports = __webpack_public_path__ + "img/Photo29.392c576b.jpg";